<template>
  <div>
    <div class="w-32 mx-auto pt-14">
      <logo-black :width="'w-32'" :height="'h-12'"></logo-black>
    </div>
    <div class="pt-7">
      <div class="text-2xl font-extrabold">Sign In</div>
    </div>
    <div class="text-left px-6">
      <div class="pt-6">
        <div class="text-xs">Please register with your phone number</div>
      </div>
      <div class="pt-6">
        <input-text type="text" placeholder="Phone"></input-text>
        <span class="text-xs">e.g +2349077877777 and not 09077877777</span>
      </div>
      <div class="pt-7 text-xs" @click="next">
        <input-button>Login</input-button>
      </div>
    </div>
    <div class="pt-7 text-xs">
      <div>
        New User?
        <div class="font-bold text-nw-red inline-block" @click="signUp">Sign Up</div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoBlack from './../components/icons/LogoBlack.vue'
import InputButton from './../components/inputs/InputButton.vue'
import InputText from './../components/inputs/InputText.vue'
export default {
  components: { LogoBlack, InputText, InputButton },
  methods: {
    signUp() {
      this.$router.push({
        name: 'Register'
      })
    },
    next() {
      this.$router.push({
        name: 'Dashboard'
      })
    }
  }
}
</script>
